import { render, staticRenderFns } from "./tag-manage.vue?vue&type=template&id=4a23c0a8&scoped=true"
import script from "./tag-manage.vue?vue&type=script&lang=js"
export * from "./tag-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a23c0a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a23c0a8')) {
      api.createRecord('4a23c0a8', component.options)
    } else {
      api.reload('4a23c0a8', component.options)
    }
    module.hot.accept("./tag-manage.vue?vue&type=template&id=4a23c0a8&scoped=true", function () {
      api.rerender('4a23c0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backend/components/tag-manage.vue"
export default component.exports